import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 30px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 10px;
  background: transparent;

  & svg {
    fill: ${({ theme }) => theme.colors.blue};
    font-size: 3.5rem;
    border-bottom: 1px dashed ${({ theme }) => theme.colors.lightGray};
    padding: 10px;
  }

  & span {
    font-size: 1rem;
    max-width: 100px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray};
    margin: 10px;
  }

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.blue};

    & svg {
      border-color: ${({ theme }) => theme.colors.blue};
    }

    & span {
      color: ${({ theme }) => theme.colors.blue};
    }
  }
`;
